import { useIntl } from "react-intl";
import { Button } from "@/components/design/Button";
import type { DocumentResource } from "@/lib/document-resource";
import { ArrowOpenIcon, PreviewIcon } from "./icons";

/** Preview affordance and capability stay together, independent of the containing page. */
export function DocumentOpenButton({ name, resource, editor = false, onOpen, disabled, id, openLabel }: {
  name: string; resource?: DocumentResource; editor?: boolean; onOpen: () => void; disabled?: boolean; id?: string; openLabel?: string;
}) {
  const intl = useIntl();
  const previewable = !editor && resource?.previewable;
  const unavailable = !editor && resource?.unavailableReason;
  const label = unavailable ? intl.formatMessage({ id: `documents.preview.${unavailable}` }) : !previewable && openLabel ? openLabel : intl.formatMessage(previewable ? { id: "documents.preview.open" } : { id: "service.docItemRow.open" });
  return <Button id={id} variant="icon" size="sm" disabled={disabled || Boolean(unavailable)} onClick={onOpen} title={label} aria-label={previewable ? `${label}: ${name}` : label}>
    {previewable ? <PreviewIcon /> : <ArrowOpenIcon />}
  </Button>;
}
